module.exports = __webpack_public_path__ + "img/logo_uajy.f6530b26.png";